import debounce from 'lodash.debounce';

import { validateZipFormat, validateZipAsync } from '#shared/util/validateZip.js';
import env from '#shared/config/env.js';

import validateField from './validateField.js';

/**
 * Export the Vue plugin install method
 * @param {object} Vue Vue instance
 */
export const install = (Vue) => {
	Vue.mixin({
		methods: {
			validateCountry(event, customer, zipSelector, countrySelector) {
				const zipCodeInput = document.getElementById(zipSelector);
				if (this.inputGroupErrors) {
					this.inputGroupErrors = this.validateField(event, 'string', `${countrySelector}_error`, {
						errors: this.inputGroupErrors,
						labelFor: countrySelector,
						errorMessage: this.t('form_errorCountry')
					});
				}
				if (zipCodeInput && zipCodeInput.value) {
					this.validateZip(zipCodeInput, customer);
				}
			},
			validateField,
			validateZipFormat,
			validateZipAsync: debounce(async function(zipCodeInput, customer, zipCodeSuggestion) {
				// @note We use .apply here so we can pass correct context of Vue component to the validateZipAsync method
				const {
					zipCodeNote,
					lastZipCode,
					zipCodeState,
					zipCodeCity
				} = await validateZipAsync.apply(this, [zipCodeInput, customer, this.inputGroupNote, this.lastZipCode, this.zipCodeState, this.zipCodeCity, this.inputGroupErrors && Array.isArray(this.inputGroupErrors) && !this.inputGroupErrors.length, this.t('form_noteZipCode')]);
				this.inputGroupNote = zipCodeSuggestion || zipCodeNote;
				this.lastZipCode = lastZipCode;
				this.zipCodeState = zipCodeState;
				this.zipCodeCity = zipCodeCity;
				if (env.zipMapCountries.includes(customer.billing.country)) {
					// Set customer state and city for the zip code
					const customerState = this.$store.state.customer;
					this.$store.commit('SET_CUSTOMER', {
						...customerState,
						billing: {
							...customerState.billing,
							city: zipCodeCity,
							state: zipCodeState
						}
					});
				}
				this.$store.commit('SET_ZIP_VALIDATION_STATE', 'done');
			}, 750),
			validateZip(zipCodeInput, customer, shouldValidateZipFormat = true, shouldShowSuggestion = false) {
				this.$store.commit('SET_ZIP_VALIDATION_STATE', 'running');
				// @todo in case of this variant CART-3170 winning, replace "form_errorZipCode" string in the localization file
				const cart3170 = this.isCustomId['CART-3170'];
				const zipCodeErrorMessage = cart3170 ? this.t('cart3170_form_errorZipCode') : this.t('form_errorZipCode');
				const zipCodeSuggestion = cart3170 && shouldShowSuggestion ? this.t('cart3170_form_suggestionZipCode') : '';
				if (shouldValidateZipFormat && this.inputGroupErrors) {
					// Reset input groups (errors are stored in ValidateField.js - needs to be reset for the customID CART-3170)
					this.inputGroupErrors = [];
					this.inputGroupErrors = this.validateZipFormat(zipCodeInput, customer, 'billingZip_error', this.inputGroupErrors, zipCodeErrorMessage);
				}
				this.validateZipAsync(zipCodeInput, customer, zipCodeSuggestion);
			}
		}
	});
};

export default {
	install
};
